(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.main-cart__form').forEach((form) => {
    const quantities = Array.from(form.querySelectorAll('[data-cart-quantity]'));
    const error = form.querySelector('[data-cart-error]');
    const root = window.Shopify?.routes?.root || '/';
    let pendingError;
    try {
      pendingError = sessionStorage.getItem('pressoraCartError');
      sessionStorage.removeItem('pressoraCartError');
    } catch (_) { /* Storage may be blocked; cart updates must still work. */ }
    if (pendingError) {
      error.textContent = pendingError;
      error.hidden = false;
    }
    let timer;
    let inFlight;
    let checkingOut = false;
    const save = () => {
      if (inFlight) return inFlight;
      const dirty = quantities.filter((item) => item.value !== item.defaultValue);
      if (!dirty.length) return Promise.resolve(true);
      if (dirty.some((item) => !item.validity.valid || item.value === '')) {
        error.textContent = 'Enter a valid quantity to update your cart.';
        error.hidden = false;
        return Promise.resolve(false);
      }
      error.hidden = true;
      quantities.forEach((item) => { item.disabled = true; });
      inFlight = (async () => {
        try {
          for (const input of dirty) {
            const quantity = Number(input.value);
            const line = quantities.indexOf(input) + 1;
            const response = await fetch(root + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line, quantity })
            });
            if (!response.ok && !response.headers.get('content-type')?.includes('application/json')) throw new Error('Cart is temporarily busy. Please try again.');
            const cart = await response.json();
            if (!response.ok) throw new Error(cart.description || cart.message || 'Could not update your cart.');
            if (quantity > 0 && cart.items[line - 1]?.quantity !== quantity) throw new Error('That quantity is unavailable. Please choose another.');
            if (quantity === 0) {
              quantities.splice(line - 1, 1);
              input.closest('.main-cart__item').remove();
            }
            input.defaultValue = input.value;
          }
          if (!checkingOut) window.location.reload();
          return true;
        } catch (failure) {
          try { sessionStorage.setItem('pressoraCartError', `${failure.message || 'Could not confirm cart update.'} Review your cart and try again.`); } catch (_) { /* Still reload to reconcile the cart. */ }
          window.location.reload();
          return false;
        } finally {
          quantities.forEach((item) => { item.disabled = false; });
          inFlight = null;
        }
      })();
      return inFlight;
    };
    quantities.forEach((input) => {
      input.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(save, 800);
      });
      input.addEventListener('change', () => {
        clearTimeout(timer);
        timer = setTimeout(save, 350);
      });
    });
    form.addEventListener('submit', async (event) => {
      if (event.submitter?.name !== 'checkout' || (!inFlight && !quantities.some((input) => input.value !== input.defaultValue))) return;
      event.preventDefault();
      checkingOut = true;
      clearTimeout(timer);
      const saved = await save();
      if (saved) window.location.assign(root + 'checkout');
      else checkingOut = false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('.main-collection__filter-toggle').forEach((details) => {
    const desktop = window.matchMedia('(min-width: 760px)');
    const sync = () => { details.open = desktop.matches; };
    sync();
    desktop.addEventListener('change', sync);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  // Shopify reports customer-form results to every newsletter form on the page.
  // Remember which one was submitted so the other signup remains available.
  const newsletterIds = ['PressoraNewsletterHome', 'PressoraNewsletterFooter'];
  const resultKey = 'pressora-newsletter-submission';
  function reconcileNewsletterResult() {
    for (const id of newsletterIds) {
      const form = document.getElementById(id);
      if (!form) continue;
      form.addEventListener('submit', () => {
        try {
          sessionStorage.setItem(resultKey, JSON.stringify({ id, path: location.pathname }));
        } catch (_) { /* Storage can be disabled; the form still submits normally. */ }
      });
    }

    const forms = newsletterIds.map(id => document.getElementById(id)).filter(Boolean);
    const contactConfirmation = document.querySelector('.contact-page__confirmation');
    contactConfirmation?.focus({ preventScroll: true });
    if (!forms.some(form => form.querySelector('[role="status"], [role="alert"]'))) return;
    let saved;
    try { saved = JSON.parse(sessionStorage.getItem(resultKey) || 'null'); sessionStorage.removeItem(resultKey); }
    catch (_) { saved = null; }
    const anchor = location.hash.slice(1);
    const source = forms.find(form => form.id === anchor) ||
      forms.find(form => form.id === saved?.id && location.pathname === saved.path) ||
      forms.find(form => form.id === 'PressoraNewsletterHome') || forms[0];

    for (const form of forms) {
      const message = form.querySelector('[role="status"], [role="alert"]');
      if (!message) continue;
      if (form !== source) {
        message.remove();
        const email = form.querySelector('input[type="email"]');
        email?.removeAttribute('aria-invalid');
        email?.removeAttribute('aria-describedby');
      } else if (message.getAttribute('role') === 'status') {
        form.querySelectorAll('label, input:not([type="hidden"]), button').forEach(field => field.remove());
        message.focus({ preventScroll: true });
        message.scrollIntoView({ block: 'center' });
      } else {
        message.scrollIntoView({ block: 'center' });
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcileNewsletterResult, { once: true });
  } else {
    reconcileNewsletterResult();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const thumbs = section.querySelectorAll('[data-product-thumb]');
    const mediaItems = section.querySelectorAll('[data-product-media]');

    const showMedia = (target) => {
      thumbs.forEach((item) => {
        const isActive = item.dataset.productThumb === target;
        item.classList.toggle('is-active', isActive);
        item.toggleAttribute('aria-current', isActive);
      });
      mediaItems.forEach((item) => {
        const isActive = item.dataset.productMedia === target;
        item.classList.toggle('is-active', isActive);
        item.hidden = !isActive;
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => showMedia(thumb.dataset.productThumb));
    });

    const variantInput = section.querySelector('[name="id"]');
    const variantData = section.querySelector('[data-product-variants]');
    const addButton = section.querySelector('[name="add"]');
    const form = section.querySelector('.main-product__form');
    const dialog = section.querySelector('[data-cart-confirmation]');
    const addError = section.querySelector('[data-add-error]');
    const uncertainLink = section.querySelector('[data-cart-uncertain-link]');
    let addPending = false;
    let addUncertain = false;
    if (form && dialog && addButton) {
      const close = () => dialog.close();
      dialog.querySelectorAll('[data-cart-dismiss]').forEach((button) => button.addEventListener('click', close));
      form.addEventListener('submit', async (event) => {
        if (event.submitter && event.submitter !== addButton) return;
        event.preventDefault();
        if (addButton.disabled || addPending || addUncertain) return;
        addError.hidden = true;
        uncertainLink.hidden = true;
        addPending = true;
        addButton.disabled = true;
        let uncertain = true;
        const root = window.Shopify?.routes?.root || '/';
        try {
          const response = await fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form) });
          if (!response.ok && [400, 401, 403, 404, 409, 422, 429].includes(response.status)) uncertain = false;
          if (!response.ok && !response.headers.get('content-type')?.includes('application/json')) throw new Error('Cart is temporarily busy. Please wait a moment and try again.');
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'This item could not be added.');
          const item = result.items?.[0] || result;
          dialog.querySelector('[data-cart-title]').textContent = item.product_title || item.title || '';
          const variant = item.options_with_values?.filter(({ name, value }) => name !== 'Title' && value !== 'Default Title').map(({ name, value }) => `${name}: ${value}`).join(' · ') || (item.variant_title === 'Default Title' ? '' : item.variant_title || '');
          dialog.querySelector('[data-cart-variant]').textContent = variant;
          const image = dialog.querySelector('[data-cart-image]');
          const imageUrl = item.featured_image?.url || item.image;
          image.hidden = !imageUrl;
          if (imageUrl) image.src = imageUrl;
          const view = dialog.querySelector('[data-cart-view]');
          const countError = dialog.querySelector('[data-cart-count-error]');
          view.textContent = 'View cart';
          countError.hidden = true;
          try {
            let cart;
            for (let attempt = 0; attempt < 2; attempt++) {
              const cartResponse = await fetch(root + 'cart.js');
              if (cartResponse.ok) { cart = await cartResponse.json(); break; }
            }
            if (!cart || !Number.isInteger(cart.item_count)) throw new Error('Unable to refresh cart count');
            view.textContent = `View cart (${cart.item_count})`;
            document.querySelectorAll('.site-header__cart').forEach((link) => {
              let badge = link.querySelector('.site-header__cart-count');
              if (!badge) { badge = document.createElement('span'); badge.className = 'site-header__cart-count'; link.append(badge); }
              badge.textContent = cart.item_count;
            });
          } catch (_) {
            countError.textContent = 'Item added. Cart count is temporarily unavailable; view your cart to confirm.';
            countError.hidden = false;
          }
          dialog.showModal();
          uncertain = false;
        } catch (error) {
          addError.textContent = uncertain ? 'We could not confirm whether this item was added. Check your cart before trying again.' : (error.message || 'Unable to add this item. Please try again.');
          addError.hidden = false;
          uncertainLink.hidden = !uncertain;
        } finally {
          addPending = false;
          addUncertain = uncertain;
          const selectedVariant = JSON.parse(variantData.textContent).find((variant) => String(variant.id) === variantInput.value);
          addButton.disabled = addUncertain || !selectedVariant?.available;
        }
      });
    }
    const price = section.querySelector('.main-product__price');
    const priceTemplates = section.querySelectorAll('[data-variant-price]');

    if (variantInput && variantData) {
      const variants = JSON.parse(variantData.textContent);
      variantInput.addEventListener('change', () => {
        const variant = variants.find((item) => String(item.id) === variantInput.value);
        if (!variant) return;

        const mediaId = variant.featured_media?.id || section.dataset.defaultMediaId;
        const media = Array.from(mediaItems).find((item) => item.dataset.mediaId === String(mediaId));
        if (media) showMedia(media.dataset.productMedia);

        if (addButton) {
          addButton.disabled = addPending || addUncertain || !variant.available;
          addButton.textContent = variant.available ? section.dataset.addLabel : section.dataset.soldOutLabel;
        }
        const priceTemplate = Array.from(priceTemplates).find((item) => item.dataset.variantPrice === String(variant.id));
        if (price && priceTemplate) price.innerHTML = priceTemplate.innerHTML;

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      });
    }

    const quantity = section.querySelector('input[name="quantity"]');
    const decrease = section.querySelector('[data-quantity-decrease]');
    const increase = section.querySelector('[data-quantity-increase]');

    if (quantity && decrease && increase) {
      decrease.addEventListener('click', () => {
        quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
      });

      increase.addEventListener('click', () => {
        quantity.value = Number(quantity.value || 1) + 1;
      });
    }

    const tabs = section.querySelectorAll('[data-product-tab]');
    const panels = section.querySelectorAll('[data-product-panel]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.productTab;

        tabs.forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.productPanel !== target;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  document.querySelectorAll('.main-search__filter-disclosure').forEach((details) => {
    const desktop = window.matchMedia('(min-width: 760px)');
    const sync = () => { details.open = desktop.matches; };
    sync();
    desktop.addEventListener('change', sync);
  });

  } catch(e) { console.error(e); }
})();
})();
